<template>
  <a-modal
    :open="props.visible"
    :title="props.title"
    :body-style="bodyStyles"
    :footer="null"
    @cancel="emits('onClose')"
    centered
  >
    <div class="modal__media">
      <!--IMAGEN-->
      <img
        v-if="props.type === 'image'"
        :src="props.url"
        class="modal__media__content"
        alt="previsualizacion de imagen"
      />
      <!--VIDEO-->
      <video v-if="props.type === 'video'" class="modal__media__content" controls>
        <source :src="props.url" type="video/mp4" />
      </video>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
const props = defineProps({
  visible: {
    type: Boolean,
    required: false,
    default: false,
  },
  title: {
    type: String,
    required: false,
    default: "Previsualización de multimedia",
  },
  type: {
    type: String,
    required: true,
    enum: ["image", "video", "document"],
  },
  url: {
    type: String,
    required: true,
  },
});

const emits = defineEmits(["onClose"]);
const bodyStyles = {
  height: "400px",
};
</script>

<style lang="sass" scoped>
.modal__media
  height: 100%
  max-width: 100%
  text-align: center
  display: flex
  align-items: center
  justify-content: center
  &__content
    max-height: 100%
    max-width: 100%
    background: $gray-5
    min-height: 20em
</style>
